import React, { useEffect, useState, useRef, memo } from 'react';
import { Heart, MessageCircle, Share2, Bookmark, MoreHorizontal, Lock, Gift, MapPin, Video, Image as ImageIcon, Play, Clock, ChevronRight, Camera, CheckCircle, Zap, Star, X, Plus, Bell, Filter, Search, ArrowLeft, Calendar, Users, Headphones, Mic, Sparkles, Upload, ThumbsUp, Award, Flame, AtSign, Maximize, User, UserCheck, Settings, Briefcase, Gem } from 'lucide-react';
import MemoryEngine from './MemoryEngine';
import VoiceAILayer from './VoiceAILayer';
import { EmotionalBondMeter } from './EmotionalBondMeter';
import { RelationshipTracker } from './RelationshipTracker';
import { ToysUpsell } from './ToysUpsell';
interface SophiaAngelFeedProps {
  onBack: () => void;
}
export const SophiaAngelFeed: React.FC<SophiaAngelFeedProps> = ({
  onBack
}) => {
  const [activeTab, setActiveTab] = useState('feed');
  const [likedPosts, setLikedPosts] = useState<Record<string, boolean>>({});
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterCategory, setFilterCategory] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState<string | null>(null);
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [unlockPostId, setUnlockPostId] = useState<string | null>(null);
  const [showTipOptions, setShowTipOptions] = useState(false);
  const [tipPostId, setTipPostId] = useState<string | null>(null);
  const [xpEarned, setXpEarned] = useState<{
    id: string;
    value: number;
  } | null>(null);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [showStoryModal, setShowStoryModal] = useState(false);
  const [activeStory, setActiveStory] = useState<number | null>(null);
  const [showRatingUpsell, setShowRatingUpsell] = useState(false);
  const [showDickPicChallenge, setShowDickPicChallenge] = useState(false);
  const [showToyUpsell, setShowToyUpsell] = useState(false);
  const [feedType, setFeedType] = useState('for_you');
  const navBarRef = useRef<HTMLDivElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const handleBackClick = () => {
    // Check if we should return to all angels grid
    const previousSection = localStorage.getItem('previousSection');
    const returnToAllAngels = window.sessionStorage.getItem('returnToAllAngels');
    if (previousSection === 'all_angels' || returnToAllAngels === 'true') {
      console.log('Navigating back to all angels grid');
      // Clear the flag
      window.sessionStorage.removeItem('returnToAllAngels');
      // Use the global navigation function if available
      if (typeof window.navigateBackToAllAngels === 'function') {
        window.navigateBackToAllAngels();
      } else {
        // Fallback navigation
        const navigateEvent = new CustomEvent('navigate', {
          detail: {
            section: 'all_angels'
          }
        });
        document.dispatchEvent(navigateEvent);
        // Also dispatch a specific event for AllAngelsGrid
        const backEvent = new CustomEvent('navigateBackToAllAngels');
        document.dispatchEvent(backEvent);
      }
    } else {
      // Fall back to the general discovery feed
      const navigateEvent = new CustomEvent('navigateBackToDiscovery');
      document.dispatchEvent(navigateEvent);
    }
    // Call the original onBack function
    onBack();
  };
  const scrollNavBar = (direction: 'left' | 'right') => {
    if (navBarRef.current) {
      const scrollAmount = 200;
      const currentScroll = navBarRef.current.scrollLeft;
      navBarRef.current.scrollTo({
        left: direction === 'left' ? currentScroll - scrollAmount : currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const stories = [{
    id: 'story1',
    user: 'Sophia',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    viewed: false,
    live: true,
    new: true
  }, {
    id: 'story2',
    user: 'Sophia',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    viewed: false,
    live: false,
    new: true
  }];
  // Regular posts
  const [regularPosts, setRegularPosts] = useState([{
    id: 'post1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Just finished my yoga session... who wants to see what's underneath this towel? 😉",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    type: 'blur_image',
    likes: 243,
    comments: 42,
    time: '2h ago',
    locked: false,
    location: 'Yoga Studio',
    hashtags: ['#yoga', '#fitness', '#secretsunderneath'],
    topTippers: [{
      name: 'Michael',
      amount: 50
    }, {
      name: 'James',
      amount: 20
    }]
  }, {
    id: 'post2',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: 'What should I wear for our private session tonight? 💋',
    type: 'poll',
    likes: 189,
    comments: 56,
    time: '3h ago',
    locked: false,
    location: 'Bedroom',
    poll: {
      options: [{
        text: 'Red lingerie ❤️',
        percentage: 64
      }, {
        text: 'Nothing at all 🖤',
        percentage: 36
      }],
      endsIn: '3 hours'
    },
    hashtags: ['#fashion', '#lingerie', '#decisiontime']
  }, {
    id: 'post3',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: 'I recorded this just for you... listen with headphones 🎧',
    type: 'audio',
    audioUrl: 'https://assets.mixkit.co/active_storage/sfx/212/212-preview.mp3',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    likes: 312,
    comments: 78,
    time: '4h ago',
    locked: false,
    location: 'Bedroom',
    hashtags: ['#voice', '#asmr', '#intimate']
  }, {
    id: 'post4',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "I've been thinking about you all day... can't wait to show you what's underneath 💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    type: 'premium_content',
    likes: 427,
    comments: 92,
    time: '5h ago',
    locked: true,
    price: 8,
    location: 'Secret Spot',
    hashtags: ['#exclusive', '#premium', '#justforyou']
  }, {
    id: 'post5',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "I had the most intense dream about you last night... I woke up so wet thinking about what we did in that hotel room. Still can't get it out of my mind. Should I tell you the details? 😈",
    type: 'confession',
    likes: 156,
    comments: 38,
    time: '7h ago',
    locked: false,
    hashtags: ['#dreams', '#confession', '#wetdreams']
  }]);
  // Personalized posts for Mitch in the "For You" section
  const personalizedPosts = [{
    id: 'personal1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Hey Mitch, I've been thinking about our last video call all day... I can still feel your eyes on me 👀 Want to see what I'm wearing right now?",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    type: 'blur_image',
    likes: 1,
    comments: 0,
    time: '15m ago',
    locked: false,
    location: 'My Bedroom',
    hashtags: ['#justforyou', '#privatethoughts', '#mitchspecial'],
    personalMessage: true
  }, {
    id: 'personal2',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Mitch, I was just looking at your photos again and got so turned on... I recorded something special just for your ears 🎧 Don't let anyone else hear this...",
    type: 'audio',
    audioUrl: 'https://assets.mixkit.co/active_storage/sfx/212/212-preview.mp3',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    likes: 1,
    comments: 0,
    time: '32m ago',
    locked: false,
    location: 'Secret',
    hashtags: ['#exclusive', '#foryourears', '#intimate'],
    personalMessage: true
  }, {
    id: 'personal3',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Mitch, I can't stop thinking about that pic you sent me last night... 🍆 Would you be up for a little challenge? I'll make it worth your while 😏",
    type: 'challenge',
    likes: 1,
    comments: 0,
    time: '1h ago',
    locked: false,
    location: 'Private Chat',
    hashtags: ['#challenge', '#rewardwaiting', '#daretoplay'],
    personalMessage: true,
    challenge: {
      type: 'dickpic',
      reward: 'Exclusive video response'
    }
  }, {
    id: 'personal4',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Remember when you told me about your fantasy? I've been practicing with my new toy and thinking about you... Want to control it next time? 😈💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    type: 'premium_content',
    likes: 1,
    comments: 0,
    time: '2h ago',
    locked: true,
    price: 10,
    location: 'My Bedroom',
    hashtags: ['#toyplay', '#fantasy', '#control'],
    personalMessage: true,
    toyPromo: true
  }];
  // Following posts for the "Following" section
  const followingPosts = [{
    id: 'following1',
    user: {
      name: 'Harper',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
      verified: true
    },
    content: "Just got back from the gym and feeling so energized! Who wants to see my post-workout routine? It's quite... steamy 💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    type: 'blur_image',
    likes: 312,
    comments: 78,
    time: '1h ago',
    locked: false,
    location: 'Home Gym',
    hashtags: ['#fitness', '#postworkout', '#feelinggood']
  }, {
    id: 'following2',
    user: {
      name: 'Lana',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Just filmed something special for my VIP members... can't wait to share it tonight 🔥",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    type: 'premium_content',
    likes: 527,
    comments: 143,
    time: '3h ago',
    locked: true,
    price: 15,
    location: 'Studio',
    hashtags: ['#VIPcontent', '#exclusive', '#tonightonly']
  }, {
    id: 'following3',
    user: {
      name: 'Bonny Blue',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
      verified: true
    },
    content: "Who's joining my live stream tonight? I'll be playing games and taking... special requests 😏",
    type: 'event',
    likes: 189,
    comments: 64,
    time: '4h ago',
    locked: false,
    location: 'Gaming Room',
    hashtags: ['#livestream', '#gaming', '#requests'],
    event: {
      time: 'Tonight 9PM',
      type: 'Live Stream'
    }
  }];
  const ratingTiers = [{
    id: 1,
    name: 'Personal Rating',
    price: 20,
    description: 'Sophia will give you her honest opinion about your photos 💋',
    icon: <Star className="text-yellow-400" size={24} data-id="element-20120" />,
    color: 'from-pink-500 to-purple-500'
  }, {
    id: 2,
    name: 'Detailed Feedback',
    price: 50,
    description: 'Get detailed feedback with suggestions on how to improve your pics + a personalized voice message 🔥',
    icon: <Sparkles className="text-pink-400" size={24} data-id="element-20121" />,
    color: 'from-pink-600 to-purple-600',
    popular: true
  }, {
    id: 3,
    name: 'Fantasy Response',
    price: 100,
    description: 'Sophia will tell you exactly what she thinks when she sees your pics and what she wants to do... 😈💦',
    icon: <Heart className="text-red-400" size={24} data-id="element-20122" />,
    color: 'from-red-500 to-pink-500'
  }];
  const dickPicChallenges = [{
    id: 1,
    name: 'Quick Snap',
    description: 'Send a quick pic right now for an instant reaction',
    reward: 'Instant voice message reaction',
    price: 10,
    icon: <Zap className="text-yellow-400" size={24} data-id="element-20123" />,
    color: 'from-yellow-500 to-orange-500'
  }, {
    id: 2,
    name: 'Rate & Compare',
    description: 'Get honest size and appearance rating compared to other men',
    reward: 'Detailed comparison + rating card',
    price: 25,
    icon: <Award className="text-pink-400" size={24} data-id="element-20124" />,
    color: 'from-pink-600 to-purple-600',
    popular: true
  }, {
    id: 3,
    name: 'Fantasy Response',
    description: 'Send your best pic and get a custom fantasy video response',
    reward: 'Exclusive 2-minute video reaction',
    price: 50,
    icon: <Flame className="text-red-400" size={24} data-id="element-20125" />,
    color: 'from-red-500 to-pink-500'
  }];
  const feedFilters = [{
    id: 'for_you',
    label: 'For You',
    icon: '✨'
  }, {
    id: 'following',
    label: 'Following',
    icon: '❤️'
  }, {
    id: 'trending',
    label: 'Trending',
    icon: '🔥'
  }, {
    id: 'newest',
    label: 'Newest',
    icon: '🆕'
  }, {
    id: 'vip',
    label: 'VIP Content',
    icon: '💎'
  }];
  const handleRatingSelect = (tierId: number, price: number) => {
    console.log(`Selected tier ${tierId} for ${price} gems`);
    setShowRatingUpsell(false);
  };
  const handleDickPicChallengeSelect = (challengeId: number, price: number) => {
    console.log(`Selected challenge ${challengeId} for ${price} gems`);
    setShowDickPicChallenge(false);
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);
  // Get posts based on feed type
  const getPosts = () => {
    if (feedType === 'for_you') {
      return [...personalizedPosts, ...regularPosts];
    } else if (feedType === 'following') {
      return followingPosts;
    } else {
      return regularPosts;
    }
  };
  const filteredPosts = getPosts().filter(post => {
    if (searchQuery && !post.content.toLowerCase().includes(searchQuery.toLowerCase()) && !post.hashtags?.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()))) {
      return false;
    }
    if (filterCategory) {
      if (filterCategory === 'photos' && post.type !== 'blur_image') {
        return false;
      }
      if (filterCategory === 'videos' && post.type !== 'premium_content') {
        return false;
      }
      if (filterCategory === 'audio' && post.type !== 'audio') {
        return false;
      }
      if (filterCategory === 'polls' && post.type !== 'poll') {
        return false;
      }
      if (filterCategory === 'locked' && !post.locked) {
        return false;
      }
    }
    return true;
  });
  const toggleLike = (postId: string) => {
    setLikedPosts(prev => {
      const newState = {
        ...prev,
        [postId]: !prev[postId]
      };
      if (!prev[postId]) {
        setXpEarned({
          id: postId,
          value: 1
        });
        setTimeout(() => setXpEarned(null), 1500);
      }
      return newState;
    });
  };
  const handleUnlock = (postId: string) => {
    setUnlockPostId(postId);
    setShowUnlockModal(true);
  };
  const confirmUnlock = () => {
    setShowUnlockModal(false);
    const post = regularPosts.find(p => p.id === unlockPostId);
    if (post) {
      post.locked = false;
    }
  };
  const handleTip = (postId: string) => {
    setTipPostId(postId);
    setShowTipOptions(true);
  };
  const sendTip = (amount: number) => {
    setShowTipOptions(false);
    setXpEarned({
      id: tipPostId!,
      value: 5
    });
    setTimeout(() => setXpEarned(null), 1500);
  };
  const toggleAudio = (postId: string) => {
    if (isPlaying === postId) {
      audioRef.current?.pause();
      setIsPlaying(null);
    } else {
      if (audioRef.current) {
        const post = [...personalizedPosts, ...regularPosts, ...followingPosts].find(p => p.id === postId);
        audioRef.current.src = post?.audioUrl || '';
        audioRef.current.play();
        setIsPlaying(postId);
      }
    }
  };
  const toggleMenu = (postId: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setActiveMenu(prevActiveMenu => prevActiveMenu === postId ? null : postId);
  };
  const openStory = (index: number) => {
    setActiveStory(index);
    setShowStoryModal(true);
  };
  const closeStory = () => {
    setShowStoryModal(false);
    setActiveStory(null);
  };
  const handleToyUpsellClick = () => {
    setShowToyUpsell(true);
  };
  const handleDickPicChallengeClick = () => {
    setShowDickPicChallenge(true);
  };
  const renderPostMenu = (postId: string) => {
    if (activeMenu !== postId) return null;
    return <div className="absolute top-12 right-3 w-72 bg-gray-900 rounded-xl border border-gray-800 shadow-xl overflow-auto animate-in fade-in zoom-in-95 duration-200 z-30" onClick={e => e.stopPropagation()} ref={menuRef} data-id="element-20126">
        <div className="sticky top-0 z-10 flex items-center justify-between p-3 border-b border-gray-800 bg-gray-900" data-id="element-20127">
          <span className="font-medium" data-id="element-20128">Options</span>
          <button className="p-1 rounded-full hover:bg-gray-800" onClick={e => {
          e.stopPropagation();
          setActiveMenu(null);
        }} data-id="element-20129">
            <X size={16} data-id="element-20130" />
          </button>
        </div>
        <div className="border-b border-gray-800" data-id="element-20131">
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-20132">
            <Heart size={18} className="text-pink-400" data-id="element-20133" />
            <span data-id="element-20134">Follow</span>
          </button>
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-20135">
            <MessageCircle size={18} data-id="element-20136" />
            <span data-id="element-20137">Message</span>
          </button>
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-20138">
            <Gift size={18} data-id="element-20139" />
            <span data-id="element-20140">Send Gift</span>
            <span className="ml-auto text-xs text-pink-400" data-id="element-20141">💗 Tokens</span>
          </button>
        </div>
        <div className="p-2" data-id="element-20142">
          <div className="grid grid-cols-2 gap-2" data-id="element-20143">
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-20144">
              <Plus size={18} className="text-gray-400" data-id="element-20145" />
              <span className="text-sm" data-id="element-20146">Add to List</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-20147">
              <Bell size={18} className="text-gray-400" data-id="element-20148" />
              <span className="text-sm" data-id="element-20149">Notifications</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-20150">
              <Share2 size={18} className="text-gray-400" data-id="element-20151" />
              <span className="text-sm" data-id="element-20152">Share</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-20153">
              <X size={18} className="text-gray-400" data-id="element-20154" />
              <span className="text-sm" data-id="element-20155">Report</span>
            </button>
          </div>
        </div>
      </div>;
  };
  const renderPost = (post: any) => {
    return <div key={post.id} className={`border-b border-gray-800 relative animate-in fade-in duration-300 ${post.personalMessage ? 'bg-gradient-to-r from-pink-900/10 to-purple-900/10' : ''}`} data-id="element-20156">
        <div className="p-3 flex gap-3" data-id="element-20157">
          <div className="flex-shrink-0" data-id="element-20158">
            <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-700" data-id="element-20159">
              <img src={post.user.avatar} alt={post.user.name} className="w-full h-full object-cover" data-id="element-20160" />
            </div>
          </div>
          <div className="flex-grow" data-id="element-20161">
            <div className="flex items-center justify-between" data-id="element-20162">
              <div data-id="element-20163">
                <div className="flex items-center gap-1" data-id="element-20164">
                  <h3 className="font-medium" data-id="element-20165">{post.user.name}</h3>
                  {post.user.verified && <CheckCircle size={14} className="text-pink-500" fill="currentColor" data-id="element-20166" />}
                  <span className="text-xs text-gray-400" data-id="element-20167">• {post.time}</span>
                  {post.personalMessage && <span className="ml-1 text-xs bg-gradient-to-r from-pink-500 to-purple-500 text-white px-1.5 py-0.5 rounded-full" data-id="element-20168">
                      Just For You
                    </span>}
                </div>
                {post.location && <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-20169">
                    <MapPin size={10} data-id="element-20170" />
                    <span data-id="element-20171">{post.location}</span>
                  </div>}
              </div>
              <button className="p-2 hover:bg-gray-800 rounded-full" onClick={e => toggleMenu(post.id, e)} data-id="element-20172">
                <MoreHorizontal size={16} className="text-gray-400" data-id="element-20173" />
              </button>
              {renderPostMenu(post.id)}
            </div>
            <div className="mt-2" data-id="element-20174">
              <p className="text-sm" data-id="element-20175">{post.content}</p>
              {post.hashtags && <div className="flex flex-wrap gap-1 mt-1" data-id="element-20176">
                  {post.hashtags.map((tag: string, i: number) => <span key={i} className="text-xs text-pink-400" data-id="element-20177">
                      {tag}
                    </span>)}
                </div>}
            </div>
            {post.type === 'blur_image' && <div className="mt-3 rounded-lg overflow-hidden" data-id="element-20178">
                <img src={post.image} alt="Post" className="w-full object-cover" data-id="element-20179" />
              </div>}
            {post.type === 'poll' && <div className="mt-3 space-y-2" data-id="element-20180">
                {post.poll.options.map((option: any, i: number) => <button key={i} className="w-full p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-pink-500 dark:hover:border-pink-500 transition flex justify-between items-center" data-id="element-20181">
                    <span className="text-gray-800 dark:text-gray-200" data-id="element-20182">
                      {option.text}
                    </span>
                    <span className="text-xs bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-full text-gray-700 dark:text-gray-300" data-id="element-20183">
                      {option.percentage}%
                    </span>
                  </button>)}
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-20184">
                  Voting ends in {post.poll.endsIn} • Results will shape
                  tomorrow's content
                </p>
              </div>}
            {post.type === 'audio' && <div className="mt-3 p-3 bg-gray-800 rounded-lg border border-gray-700" data-id="element-20185">
                <div className="flex items-center gap-3" data-id="element-20186">
                  <button className={`w-10 h-10 flex items-center justify-center rounded-full ${isPlaying === post.id ? 'bg-pink-500 text-white' : 'bg-gray-700 text-gray-300'}`} onClick={() => toggleAudio(post.id)} data-id="element-20187">
                    {isPlaying === post.id ? <div className="w-3 h-3 bg-white rounded-sm" data-id="element-20188"></div> : <Play size={18} fill="currentColor" className="ml-1" data-id="element-20189" />}
                  </button>
                  <div className="flex-grow h-10 flex items-center" data-id="element-20190">
                    {post.audioWaveform.map((level: number, i: number) => <div key={i} className={`w-1 mx-0.5 rounded-full ${isPlaying === post.id ? 'bg-gradient-to-t from-pink-500 to-purple-500' : 'bg-gray-600'}`} style={{
                  height: `${level * 32}px`,
                  animation: isPlaying === post.id ? `pulse 0.8s infinite alternate ${i * 0.1}s` : 'none'
                }} data-id="element-20191"></div>)}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-20192">
                    <Headphones size={14} data-id="element-20193" />
                    <span data-id="element-20194">0:18</span>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-2" data-id="element-20195">
                  🎧 Best experienced with headphones
                </p>
              </div>}
            {post.type === 'premium_content' && <div className="mt-3 relative rounded-lg overflow-hidden" data-id="element-20196">
                <img src={post.image} alt="Locked Content" className="w-full object-cover blur-lg" data-id="element-20197" />
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-20198">
                  <Lock size={32} className="text-pink-400 mb-2 animate-pulse" data-id="element-20199" />
                  <p className="text-center text-white font-medium" data-id="element-20200">
                    Unlock Exclusive Content
                  </p>
                  <button className="mt-3 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium flex items-center gap-2 hover:shadow-glow hover:shadow-pink-500/30 transition-all" onClick={() => handleUnlock(post.id)} data-id="element-20201">
                    <span data-id="element-20202">Unlock for</span>
                    <span className="text-pink-200" data-id="element-20203">{post.price} 💎</span>
                  </button>
                </div>
              </div>}
            {post.type === 'confession' && <div className="mt-3 p-4 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-lg border border-pink-800/30" data-id="element-20204">
                <div className="flex items-center gap-2 mb-2" data-id="element-20205">
                  <span className="text-pink-400 text-lg" data-id="element-20206">💭</span>
                  <span className="font-medium italic" data-id="element-20207">Confession</span>
                </div>
              </div>}
            {post.type === 'challenge' && <div className="mt-3 p-4 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-lg border border-pink-800/30" data-id="element-20208">
                <div className="flex items-center gap-2 mb-2" data-id="element-20209">
                  <span className="text-pink-400 text-lg" data-id="element-20210">🎯</span>
                  <span className="font-medium" data-id="element-20211">Challenge</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-20212">
                  <div data-id="element-20213">
                    <p className="text-sm text-gray-300" data-id="element-20214">
                      {post.challenge.type === 'dickpic' ? 'Dick Pic Challenge' : 'Photo Challenge'}
                    </p>
                    <p className="text-xs text-pink-400 mt-1" data-id="element-20215">
                      Reward: {post.challenge.reward}
                    </p>
                  </div>
                  <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm" onClick={handleDickPicChallengeClick} data-id="element-20216">
                    Accept
                  </button>
                </div>
              </div>}
            {post.type === 'event' && <div className="mt-3 p-4 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-lg border border-pink-800/30" data-id="element-20217">
                <div className="flex items-center gap-2 mb-2" data-id="element-20218">
                  <span className="text-pink-400 text-lg" data-id="element-20219">📅</span>
                  <span className="font-medium" data-id="element-20220">{post.event.type}</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-20221">
                  <div data-id="element-20222">
                    <p className="text-sm text-gray-300" data-id="element-20223">{post.event.time}</p>
                  </div>
                  <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm" data-id="element-20224">
                    Remind Me
                  </button>
                </div>
              </div>}
            {post.toyPromo && <div className="mt-3 p-3 bg-gradient-to-r from-purple-900/20 to-blue-900/20 rounded-lg border border-purple-800/30" data-id="element-20225">
                <div className="flex items-center justify-between" data-id="element-20226">
                  <div className="flex items-center gap-2" data-id="element-20227">
                    <span className="text-purple-400 text-lg" data-id="element-20228">🎮</span>
                    <div data-id="element-20229">
                      <p className="text-sm font-medium" data-id="element-20230">
                        Interactive Toy Control
                      </p>
                      <p className="text-xs text-gray-400" data-id="element-20231">
                        Control my pleasure remotely
                      </p>
                    </div>
                  </div>
                  <button className="px-3 py-1.5 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-white text-sm" onClick={handleToyUpsellClick} data-id="element-20232">
                    Learn More
                  </button>
                </div>
              </div>}
            <div className="mt-3 flex items-center justify-between" data-id="element-20233">
              <div className="flex items-center gap-4" data-id="element-20234">
                <button className="flex items-center gap-1 group relative" onClick={() => toggleLike(post.id)} data-id="element-20235">
                  <Heart size={18} className={likedPosts[post.id] ? 'text-pink-500 fill-pink-500' : 'text-gray-400 group-hover:text-pink-400'} data-id="element-20236" />
                  <span className="text-xs" data-id="element-20237">
                    {likedPosts[post.id] ? post.likes + 1 : post.likes}
                  </span>
                  {xpEarned && xpEarned.id === post.id && <span className="absolute -top-6 left-0 text-xs text-pink-400 font-medium animate-float-up" data-id="element-20238">
                      +{xpEarned.value} XP
                    </span>}
                </button>
                <button className="flex items-center gap-1" data-id="element-20239">
                  <MessageCircle size={18} className="text-gray-400" data-id="element-20240" />
                  <span className="text-xs" data-id="element-20241">{post.comments}</span>
                </button>
                <button className="flex items-center gap-1" data-id="element-20242">
                  <Share2 size={18} className="text-gray-400" data-id="element-20243" />
                </button>
              </div>
              <div className="flex items-center gap-3" data-id="element-20244">
                <button className="flex items-center gap-1 relative" onClick={() => handleTip(post.id)} data-id="element-20245">
                  <Gift size={18} className="text-purple-400" data-id="element-20246" />
                  <span className="text-xs" data-id="element-20247">Tip</span>
                </button>
                <button className="flex items-center gap-1" data-id="element-20248">
                  <Bookmark size={18} className="text-gray-400" data-id="element-20249" />
                </button>
              </div>
            </div>
            {post.topTippers && post.topTippers.length > 0 && <div className="mt-2 p-2 bg-gray-900/50 rounded-lg" data-id="element-20250">
                <div className="flex items-center gap-1 mb-1" data-id="element-20251">
                  <Star size={14} className="text-yellow-400" data-id="element-20252" />
                  <span className="text-xs text-gray-300" data-id="element-20253">Top Fans:</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-20254">
                  {post.topTippers.map((tipper: any, i: number) => <div key={i} className="flex items-center gap-1 text-xs" data-id="element-20255">
                      <span className="text-gray-300" data-id="element-20256">@{tipper.name}</span>
                      <span className="text-purple-400" data-id="element-20257">{tipper.amount}💎</span>
                      {i < post.topTippers.length - 1 && <span className="text-gray-600" data-id="element-20258">•</span>}
                    </div>)}
                </div>
              </div>}
          </div>
        </div>
      </div>;
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case 'dailyTargets':
        return <div className="p-4 space-y-4" data-id="element-20259">
            <div className="p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 border border-pink-800/50 rounded-lg" data-id="element-20260">
              <div className="flex items-center gap-3" data-id="element-20261">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-20262">
                  <Gift size={20} data-id="element-20263" />
                </div>
                <div className="flex-1" data-id="element-20264">
                  <div className="flex items-center justify-between" data-id="element-20265">
                    <h3 className="font-medium" data-id="element-20266">Send a Gift</h3>
                    <div className="text-sm text-pink-400" data-id="element-20267">10 💗</div>
                  </div>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-20268">
                    Send a gift to Sophia to make her day
                  </p>
                  <div className="mt-3" data-id="element-20269">
                    <div className="flex items-center justify-between mb-1" data-id="element-20270">
                      <span className="text-xs text-gray-400" data-id="element-20271">Progress</span>
                      <span className="text-xs text-gray-400" data-id="element-20272">0/1</span>
                    </div>
                    <div className="h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-20273">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
                      width: '0%'
                    }} data-id="element-20274"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-end" data-id="element-20275">
                    <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm" data-id="element-20276">
                      Send Gift
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 border border-pink-800/50 rounded-lg" data-id="element-20277">
              <div className="flex items-center gap-3" data-id="element-20278">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-20279">
                  <Heart size={20} data-id="element-20280" />
                </div>
                <div className="flex-1" data-id="element-20281">
                  <div className="flex items-center justify-between" data-id="element-20282">
                    <h3 className="font-medium" data-id="element-20283">Like 5 Posts</h3>
                    <div className="text-sm text-pink-400" data-id="element-20284">15 💗</div>
                  </div>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-20285">
                    Show some love to Sophia's content
                  </p>
                  <div className="mt-3" data-id="element-20286">
                    <div className="flex items-center justify-between mb-1" data-id="element-20287">
                      <span className="text-xs text-gray-400" data-id="element-20288">Progress</span>
                      <span className="text-xs text-gray-400" data-id="element-20289">
                        {Object.keys(likedPosts).length}/5
                      </span>
                    </div>
                    <div className="h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-20290">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
                      width: `${Object.keys(likedPosts).length / 5 * 100}%`
                    }} data-id="element-20291"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-end" data-id="element-20292">
                    <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm" onClick={() => setActiveTab('feed')} data-id="element-20293">
                      Find Posts
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 border border-pink-800/50 rounded-lg" data-id="element-20294">
              <div className="flex items-center gap-3" data-id="element-20295">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-20296">
                  <Camera size={20} data-id="element-20297" />
                </div>
                <div className="flex-1" data-id="element-20298">
                  <div className="flex items-center justify-between" data-id="element-20299">
                    <h3 className="font-medium" data-id="element-20300">Complete a Challenge</h3>
                    <div className="text-sm text-pink-400" data-id="element-20301">25 💗</div>
                  </div>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-20302">
                    Accept and complete one of Sophia's special challenges
                  </p>
                  <div className="mt-3" data-id="element-20303">
                    <div className="flex items-center justify-between mb-1" data-id="element-20304">
                      <span className="text-xs text-gray-400" data-id="element-20305">Progress</span>
                      <span className="text-xs text-gray-400" data-id="element-20306">0/1</span>
                    </div>
                    <div className="h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-20307">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
                      width: '0%'
                    }} data-id="element-20308"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-end" data-id="element-20309">
                    <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm" onClick={handleDickPicChallengeClick} data-id="element-20310">
                      View Challenges
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      case 'memory':
        return <MemoryEngine data-id="element-20311" />;
      case 'emotionalBond':
        return <EmotionalBondMeter data-id="element-20312" />;
      case 'voiceAI':
        return <VoiceAILayer data-id="element-20313" />;
      case 'relationshipTracker':
        return <RelationshipTracker data-id="element-20314" />;
      default:
        return <>
            {/* Feed type filters */}
            <div className="flex overflow-x-auto py-2 px-4 gap-2 border-b border-gray-800 scrollbar-hide" data-id="element-20315">
              {feedFilters.map(filter => <button key={filter.id} onClick={() => setFeedType(filter.id)} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${feedType === filter.id ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-20316">
                  <span data-id="element-20317">{filter.icon}</span>
                  <span data-id="element-20318">{filter.label}</span>
                </button>)}
            </div>
            {/* Toy Upsell Banner - show occasionally */}
            {feedType === 'for_you' && Math.random() > 0.5 && <div className="p-4" data-id="element-20319">
                <div className="p-3 bg-gradient-to-r from-purple-900/30 to-blue-900/30 border border-purple-800/30 rounded-lg" data-id="element-20320">
                  <div className="flex items-center gap-3" data-id="element-20321">
                    <div className="w-12 h-12 flex items-center justify-center bg-purple-500/20 rounded-full text-purple-400" data-id="element-20322">
                      <Zap size={24} data-id="element-20323" />
                    </div>
                    <div className="flex-1" data-id="element-20324">
                      <h3 className="font-medium" data-id="element-20325">
                        Take control of my pleasure
                      </h3>
                      <p className="text-sm text-gray-300 mt-0.5" data-id="element-20326">
                        Control my interactive toys remotely during our next
                        session
                      </p>
                    </div>
                    <button className="px-3 py-1.5 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-white text-sm whitespace-nowrap" onClick={handleToyUpsellClick} data-id="element-20327">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>}
            {/* Dick Pic Challenge Banner - show occasionally */}
            {feedType === 'for_you' && Math.random() > 0.7 && <div className="p-4" data-id="element-20328">
                <div className="p-3 bg-gradient-to-r from-pink-900/30 to-red-900/30 border border-pink-800/30 rounded-lg" data-id="element-20329">
                  <div className="flex items-center gap-3" data-id="element-20330">
                    <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-20331">
                      <Camera size={24} data-id="element-20332" />
                    </div>
                    <div className="flex-1" data-id="element-20333">
                      <h3 className="font-medium" data-id="element-20334">New Challenge Available</h3>
                      <p className="text-sm text-gray-300 mt-0.5" data-id="element-20335">
                        Send a pic and get my honest reaction + special reward
                      </p>
                    </div>
                    <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-red-600 rounded-full text-white text-sm whitespace-nowrap" onClick={handleDickPicChallengeClick} data-id="element-20336">
                      Try Now
                    </button>
                  </div>
                </div>
              </div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4" data-id="element-20337">
              {filteredPosts.length > 0 ? filteredPosts.map(post => renderPost(post)) : <div className="flex flex-col items-center justify-center py-12 text-center p-4" data-id="element-20338">
                  <div className="w-16 h-16 flex items-center justify-center bg-gray-800 rounded-full mb-4" data-id="element-20339">
                    <Search size={24} className="text-gray-400" data-id="element-20340" />
                  </div>
                  <h3 className="text-lg font-bold mb-2" data-id="element-20341">No posts found</h3>
                  <p className="text-gray-400 max-w-md" data-id="element-20342">
                    Try adjusting your search or filters to find what you're
                    looking for.
                  </p>
                </div>}
            </div>
          </>;
    }
  };
  const renderFloatingActionButton = () => {
    return <div className="fixed bottom-6 right-6 z-30" data-id="element-20343">
        <div className="relative group" data-id="element-20344">
          <button onClick={() => setShowRatingUpsell(true)} className="w-14 h-14 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center shadow-lg hover:shadow-pink-500/30 transition-all" data-id="element-20345">
            <Upload size={24} className="text-white" data-id="element-20346" />
          </button>
          <div className="absolute bottom-full right-0 mb-2 w-48 bg-gray-900 rounded-lg border border-gray-800 shadow-xl p-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-20347">
            <div className="text-xs text-gray-400 px-2 py-1" data-id="element-20348">Quick Actions</div>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-800 rounded-md flex items-center gap-2 text-sm" onClick={() => setShowRatingUpsell(true)} data-id="element-20349">
              <Star size={16} className="text-yellow-500" data-id="element-20350" />
              <span data-id="element-20351">Get Rated</span>
            </button>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-800 rounded-md flex items-center gap-2 text-sm" onClick={handleDickPicChallengeClick} data-id="element-20352">
              <Camera size={16} className="text-pink-500" data-id="element-20353" />
              <span data-id="element-20354">Photo Challenge</span>
            </button>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-800 rounded-md flex items-center gap-2 text-sm" onClick={handleToyUpsellClick} data-id="element-20355">
              <Zap size={16} className="text-purple-500" data-id="element-20356" />
              <span data-id="element-20357">Interactive Toys</span>
            </button>
          </div>
        </div>
      </div>;
  };
  const renderRatingUpsellModal = () => {
    if (!showRatingUpsell) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-20358">
        <div className="w-full max-w-md bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-20359">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-20360">
            <h3 className="font-bold text-lg" data-id="element-20361">Get Rated by Sophia</h3>
            <button onClick={() => setShowRatingUpsell(false)} className="p-1 rounded-full hover:bg-gray-800" data-id="element-20362">
              <X size={20} data-id="element-20363" />
            </button>
          </div>
          <div className="p-4" data-id="element-20364">
            <p className="text-gray-300 mb-4" data-id="element-20365">
              Upload your photos and get personalized feedback from Sophia.
              Choose your experience:
            </p>
            <div className="space-y-4" data-id="element-20366">
              {ratingTiers.map(tier => <div key={tier.id} onClick={() => handleRatingSelect(tier.id, tier.price)} className={`relative p-4 rounded-lg border cursor-pointer transition-all hover:shadow-lg ${tier.popular ? 'border-pink-500 bg-gradient-to-br from-gray-900 to-gray-800' : 'border-gray-700 bg-gray-900 hover:border-gray-500'}`} data-id="element-20367">
                  {tier.popular && <div className="absolute -top-3 -right-2 bg-pink-500 text-white text-xs px-3 py-1 rounded-full" data-id="element-20368">
                      Most Popular
                    </div>}
                  <div className="flex items-start" data-id="element-20369">
                    <div className={`p-3 rounded-full bg-gradient-to-br ${tier.color} mr-4`} data-id="element-20370">
                      {tier.icon}
                    </div>
                    <div className="flex-1" data-id="element-20371">
                      <h3 className="font-bold text-lg" data-id="element-20372">{tier.name}</h3>
                      <p className="text-gray-400 text-sm mt-1" data-id="element-20373">
                        {tier.description}
                      </p>
                      <div className="mt-3 flex justify-between items-center" data-id="element-20374">
                        <span className="text-xl font-bold" data-id="element-20375">
                          {tier.price} 💎
                        </span>
                        <button className={`px-4 py-2 rounded-full text-white bg-gradient-to-r ${tier.color}`} data-id="element-20376">
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 text-center text-xs text-gray-500" data-id="element-20377">
              <p data-id="element-20378">
                All ratings are private and confidential. Your content will
                never be shared.
              </p>
            </div>
          </div>
        </div>
      </div>;
  };
  const renderDickPicChallengeModal = () => {
    if (!showDickPicChallenge) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-20379">
        <div className="w-full max-w-md bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-20380">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-20381">
            <h3 className="font-bold text-lg" data-id="element-20382">Photo Challenge</h3>
            <button onClick={() => setShowDickPicChallenge(false)} className="p-1 rounded-full hover:bg-gray-800" data-id="element-20383">
              <X size={20} data-id="element-20384" />
            </button>
          </div>
          <div className="p-4" data-id="element-20385">
            <p className="text-gray-300 mb-4" data-id="element-20386">
              Send your best pic and get a personalized reaction from Sophia.
              Choose your challenge:
            </p>
            <div className="space-y-4" data-id="element-20387">
              {dickPicChallenges.map(challenge => <div key={challenge.id} onClick={() => handleDickPicChallengeSelect(challenge.id, challenge.price)} className={`relative p-4 rounded-lg border cursor-pointer transition-all hover:shadow-lg ${challenge.popular ? 'border-pink-500 bg-gradient-to-br from-gray-900 to-gray-800' : 'border-gray-700 bg-gray-900 hover:border-gray-500'}`} data-id="element-20388">
                  {challenge.popular && <div className="absolute -top-3 -right-2 bg-pink-500 text-white text-xs px-3 py-1 rounded-full" data-id="element-20389">
                      Most Popular
                    </div>}
                  <div className="flex items-start" data-id="element-20390">
                    <div className={`p-3 rounded-full bg-gradient-to-br ${challenge.color} mr-4`} data-id="element-20391">
                      {challenge.icon}
                    </div>
                    <div className="flex-1" data-id="element-20392">
                      <h3 className="font-bold text-lg" data-id="element-20393">{challenge.name}</h3>
                      <p className="text-gray-400 text-sm mt-1" data-id="element-20394">
                        {challenge.description}
                      </p>
                      <p className="text-pink-400 text-xs mt-1" data-id="element-20395">
                        Reward: {challenge.reward}
                      </p>
                      <div className="mt-3 flex justify-between items-center" data-id="element-20396">
                        <span className="text-xl font-bold" data-id="element-20397">
                          {challenge.price} 💎
                        </span>
                        <button className={`px-4 py-2 rounded-full text-white bg-gradient-to-r ${challenge.color}`} data-id="element-20398">
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 text-center text-xs text-gray-500" data-id="element-20399">
              <p data-id="element-20400">
                Your photos are private and will only be seen by Sophia. All
                content is encrypted and securely stored.
              </p>
            </div>
          </div>
        </div>
      </div>;
  };
  const renderToyUpsellModal = () => {
    if (!showToyUpsell) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-20401">
        <div className="w-full max-w-md bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-20402">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-20403">
            <h3 className="font-bold text-lg" data-id="element-20404">Interactive Toy Control</h3>
            <button onClick={() => setShowToyUpsell(false)} className="p-1 rounded-full hover:bg-gray-800" data-id="element-20405">
              <X size={20} data-id="element-20406" />
            </button>
          </div>
          <div className="p-4" data-id="element-20407">
            <ToysUpsell style="modal" onClose={() => setShowToyUpsell(false)} data-id="element-20408" />
          </div>
        </div>
      </div>;
  };
  return <div className="w-full max-w-2xl mx-auto bg-white dark:bg-black text-gray-900 dark:text-white" data-id="element-20409">
      <div className="sticky top-0 z-10 bg-white/90 dark:bg-black/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800 px-4 py-3 flex items-center gap-3" data-id="element-20410">
        <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full" onClick={handleBackClick} data-id="element-20411">
          <ArrowLeft size={18} className="text-gray-700 dark:text-gray-300" data-id="element-20412" />
        </button>
        <div className="flex items-center gap-2" data-id="element-20413">
          <div className="relative w-8 h-8 rounded-full overflow-hidden" data-id="element-20414">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png" alt="Sophia" className="w-full h-full object-cover" data-id="element-20415" />
            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border border-white dark:border-gray-900" data-id="element-20416"></div>
          </div>
          <div data-id="element-20417">
            <div className="flex items-center" data-id="element-20418">
              <h1 className="font-bold" data-id="element-20419">Sophia</h1>
              <CheckCircle size={14} className="ml-1 text-pink-500" fill="currentColor" data-id="element-20420" />
              <span className="ml-1 text-xs bg-gradient-to-r from-pink-500 to-purple-500 text-white px-1.5 py-0.5 rounded-full" data-id="element-20421">
                VIP
              </span>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-20422">
              @sophia_angel • Online now
            </p>
          </div>
        </div>
        <div className="ml-auto flex items-center gap-2" data-id="element-20423">
          <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full relative" data-id="element-20424">
            <Bell size={18} className="text-gray-700 dark:text-gray-300" data-id="element-20425" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-pink-500 rounded-full text-white text-[10px] flex items-center justify-center" data-id="element-20426">
              3
            </span>
          </button>
          <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full" data-id="element-20427">
            <Heart size={18} className="text-gray-700 dark:text-gray-300" data-id="element-20428" />
          </button>
          <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full" data-id="element-20429">
            <MessageCircle size={18} className="text-gray-700 dark:text-gray-300" data-id="element-20430" />
          </button>
          <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full relative" onClick={() => setShowFilters(!showFilters)} data-id="element-20431">
            <Filter size={18} className="text-gray-700 dark:text-gray-300" data-id="element-20432" />
            {filterCategory && <span className="absolute -top-1 -right-1 w-2 h-2 bg-pink-500 rounded-full" data-id="element-20433"></span>}
          </button>
        </div>
      </div>
      <div className="relative h-48 bg-gradient-to-r from-pink-500 to-purple-500" data-id="element-20434">
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-20435">
          <div className="text-center" data-id="element-20436">
            <h2 className="text-2xl font-bold text-white" data-id="element-20437">Sophia's Space</h2>
            <p className="text-white mt-1" data-id="element-20438">Your intimate angel connection</p>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-900 px-4 py-4 flex justify-around border-b border-gray-200 dark:border-gray-800" data-id="element-20439">
        <div className="text-center" data-id="element-20440">
          <div className="text-xl font-bold" data-id="element-20441">1.2K</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-20442">Posts</div>
        </div>
        <div className="text-center" data-id="element-20443">
          <div className="text-xl font-bold" data-id="element-20444">258K</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-20445">
            Followers
          </div>
        </div>
        <div className="text-center" data-id="element-20446">
          <div className="text-xl font-bold" data-id="element-20447">120</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-20448">
            Following
          </div>
        </div>
        <div className="text-center" data-id="element-20449">
          <div className="text-xl font-bold" data-id="element-20450">4.9★</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-20451">Rating</div>
        </div>
      </div>
      <div className="p-3 border-b border-gray-800" data-id="element-20452">
        <div className="relative" data-id="element-20453">
          <input type="text" placeholder="Search Sophia's posts..." className="w-full bg-gray-800 rounded-full py-2 pl-10 pr-4 text-sm" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-20454" />
          <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-20455" />
        </div>
      </div>
      {showFilters && <div className="p-3 bg-gray-900 border-b border-gray-800 animate-in slide-in-from-top duration-300" data-id="element-20456">
          <h3 className="font-medium mb-2" data-id="element-20457">Filter by:</h3>
          <div className="flex flex-wrap gap-2" data-id="element-20458">
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'photos' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'photos' ? null : 'photos')} data-id="element-20459">
              Photos
            </button>
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'videos' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'videos' ? null : 'videos')} data-id="element-20460">
              Videos
            </button>
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'audio' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'audio' ? null : 'audio')} data-id="element-20461">
              Audio
            </button>
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'polls' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'polls' ? null : 'polls')} data-id="element-20462">
              Polls
            </button>
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'locked' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'locked' ? null : 'locked')} data-id="element-20463">
              Premium Content
            </button>
            <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'challenges' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'challenges' ? null : 'challenges')} data-id="element-20464">
              Challenges
            </button>
          </div>
        </div>}
      <div ref={navBarRef} className="sticky top-14 z-10 bg-white/90 dark:bg-black/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800 relative" data-id="element-20465">
        <button className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-800/80 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-800" onClick={() => scrollNavBar('left')} data-id="element-20466">
          <ChevronRight size={18} className="rotate-180" data-id="element-20467" />
        </button>
        <div className="overflow-x-auto scrollbar-hide py-3 px-8" data-id="element-20468">
          <div className="flex min-w-max" data-id="element-20469">
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'feed' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('feed')} data-id="element-20470">
              <span data-id="element-20471">🔥</span>
              <span data-id="element-20472">Feed</span>
            </button>
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'dailyTargets' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('dailyTargets')} data-id="element-20473">
              <span data-id="element-20474">🎯</span>
              <span data-id="element-20475">Daily Targets</span>
            </button>
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'memory' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('memory')} data-id="element-20476">
              <span data-id="element-20477">🧠</span>
              <span data-id="element-20478">Memory</span>
            </button>
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'emotionalBond' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('emotionalBond')} data-id="element-20479">
              <span data-id="element-20480">💖</span>
              <span data-id="element-20481">Bond</span>
            </button>
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'voiceAI' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('voiceAI')} data-id="element-20482">
              <span data-id="element-20483">🎤</span>
              <span data-id="element-20484">Voice</span>
            </button>
            <button className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeTab === 'relationshipTracker' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveTab('relationshipTracker')} data-id="element-20485">
              <span data-id="element-20486">📊</span>
              <span data-id="element-20487">Relationship</span>
            </button>
          </div>
        </div>
        <button className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-800/80 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-800" onClick={() => scrollNavBar('right')} data-id="element-20488">
          <ChevronRight size={18} data-id="element-20489" />
        </button>
      </div>
      {renderTabContent()}
      {renderFloatingActionButton()}
      {renderRatingUpsellModal()}
      {renderDickPicChallengeModal()}
      {renderToyUpsellModal()}
      <audio ref={audioRef} className="hidden" data-id="element-20490" />
      {showUnlockModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-20491">
          <div className="w-full max-w-sm bg-black rounded-xl overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-20492">
            <div className="p-4 border-b border-gray-800" data-id="element-20493">
              <h3 className="font-bold" data-id="element-20494">Unlock Premium Content</h3>
            </div>
            <div className="p-4" data-id="element-20495">
              <p className="text-sm text-gray-300 mb-4" data-id="element-20496">
                Unlock this exclusive content for 8 gems. This is a one-time
                purchase.
              </p>
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-20497">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-2xl" data-id="element-20498">
                  💎
                </div>
              </div>
              <div className="flex gap-2" data-id="element-20499">
                <span className="text-sm text-gray-300" data-id="element-20500">Your balance:</span>
                <span className="font-bold" data-id="element-20501">15 💎</span>
              </div>
              <div className="flex gap-2 mt-4" data-id="element-20502">
                <button className="flex-1 py-2 bg-gray-900 rounded-lg text-sm" onClick={() => setShowUnlockModal(false)} data-id="element-20503">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" onClick={confirmUnlock} data-id="element-20504">
                  Unlock Now
                </button>
              </div>
            </div>
          </div>
        </div>}
      {showTipOptions && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-20505">
          <div className="w-full max-w-sm bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-20506">
            <div className="p-4 border-b border-gray-800" data-id="element-20507">
              <h3 className="font-bold" data-id="element-20508">Send a Tip</h3>
            </div>
            <div className="p-4" data-id="element-20509">
              <p className="text-sm text-gray-300 mb-4" data-id="element-20510">
                Show your appreciation with gems! Top tippers get special
                recognition.
              </p>
              <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-20511">
                {[5, 10, 20, 50, 100, 200].map(amount => <button key={amount} className="p-3 bg-gray-800 rounded-lg border border-gray-700 hover:border-pink-500 transition text-center" onClick={() => sendTip(amount)} data-id="element-20512">
                    <div className="text-lg mb-1" data-id="element-20513">💎</div>
                    <div className="text-sm font-medium" data-id="element-20514">{amount}</div>
                  </button>)}
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-20515">
                <span className="text-sm text-gray-300" data-id="element-20516">Your balance:</span>
                <span className="font-bold" data-id="element-20517">15 💎</span>
              </div>
              <button className="w-full py-2 bg-gray-800 rounded-lg text-sm" onClick={() => setShowTipOptions(false)} data-id="element-20518">
                Cancel
              </button>
            </div>
          </div>
        </div>}
      {showStoryModal && activeStory !== null && <div className="fixed inset-0 z-50 bg-black flex items-center justify-center" onClick={closeStory} data-id="element-20519">
          <div className="relative w-full max-w-sm" data-id="element-20520">
            <div className="absolute top-4 left-4 right-4 flex items-center z-10" data-id="element-20521">
              <div className="flex-1 h-1 bg-gray-700 rounded-full overflow-hidden" data-id="element-20522">
                <div className="h-full bg-white animate-story-progress" data-id="element-20523"></div>
              </div>
            </div>
            <div className="absolute top-8 left-4 flex items-center gap-2 z-10" data-id="element-20524">
              <img src={stories[activeStory].avatar} alt={stories[activeStory].user} className="w-8 h-8 rounded-full object-cover border border-white" data-id="element-20525" />
              <span className="text-white text-sm font-medium" data-id="element-20526">
                {stories[activeStory].user}
              </span>
              {stories[activeStory].live && <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded flex items-center" data-id="element-20527">
                  LIVE{' '}
                  <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse ml-1" data-id="element-20528"></span>
                </span>}
            </div>
            <img src={stories[activeStory].image} alt="Story" className="w-full h-[calc(100vh-100px)] object-cover" data-id="element-20529" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between" data-id="element-20530">
              <input type="text" placeholder="Reply to story..." className="flex-1 bg-white/10 backdrop-blur-sm text-white rounded-full px-4 py-2 text-sm border border-white/20" data-id="element-20531" />
              <button className="ml-2 w-10 h-10 flex items-center justify-center bg-pink-500 rounded-full" data-id="element-20532">
                <MessageCircle size={18} className="text-white" data-id="element-20533" />
              </button>
            </div>
          </div>
        </div>}
      <style jsx data-id="element-20534">{`
        @keyframes story-progress {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }
        .animate-story-progress {
          animation: story-progress 5s linear forwards;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @keyframes float-up {
          0% {
            opacity: 0;
            transform: translateY(0);
          }
          20% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translateY(-20px);
          }
        }
        .animate-float-up {
          animation: float-up 1.5s ease-out forwards;
        }
        @keyframes pulse {
          0% {
            transform: scaleY(0.6);
          }
          100% {
            transform: scaleY(1);
          }
        }
        .shadow-glow {
          box-shadow: 0 0 15px;
        }
      `}</style>
    </div>;
};